(() => {
  const mql = window.matchMedia('(max-width: 1023.98px)');
  const SELECTOR = '.sm\\:scrl-dwn-no-sticy';
  const MIN_DELTA = 6;      // ignore tiny scrolls
  const REVEAL_TOP = 80;    // always show near the top
  let lastY = window.scrollY || 0;
  let ticking = false;

  const getTargets = () => Array.from(document.querySelectorAll(SELECTOR));

  function setHidden(hidden, nodes = getTargets()) {
    nodes.forEach(el => {
      if (hidden) {
        el.style.opacity = '0';
        el.style.pointerEvents = 'none';
      } else {
        el.style.opacity = '';
        el.style.pointerEvents = '';
      }
    });
  }

  function handle() {
    // Desktop: always visible
    if (!mql.matches) { setHidden(false); lastY = window.scrollY || 0; return; }

    const y = window.scrollY || 0;
    const delta = y - lastY;

    // reveal when near top
    if (y < REVEAL_TOP) { setHidden(false); lastY = y; return; }

    if (Math.abs(delta) >= MIN_DELTA) {
      const down = delta > 0;
      setHidden(down);
      lastY = y;
    }
  }

  function onScrollRAF() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; handle(); });
  }

  function init() {
    // initial pass
    handle();

    // listen
    window.addEventListener('scroll', onScrollRAF, { passive: true });

    // when crossing breakpoint, reset to visible
    mql.addEventListener?.('change', () => { setHidden(false); lastY = window.scrollY || 0; });

    // if your theme re-renders sections, re-evaluate without repaint storms
    document.addEventListener('shopify:section:load', handle);
    document.addEventListener('collection:appended', handle);
    document.addEventListener('collection:rerendered', handle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();